<template>
  <div class="carousel-container">
    <el-carousel class="d-none d-lg-block d-xl-block" style="height: 600px">
      <el-carousel-item
        v-for="item in pcLists"
        :key="item.title"
        style="height: 600px"
      >
        <el-image style="width: 100%; height: 600px" :src="item.imgUrl" />
        <div class="carousel-captions">
          <h2>{{ item.title }}</h2>
          <p>{{ item.desc }}</p>
          <img class="carousel-btn" src="@/assets/images/btn.png" alt="">
        </div>
      </el-carousel-item>
    </el-carousel>
    <el-carousel
      class="d-sm-block d-md-block d-xl-none d-lg-none"
      style="height: 311px"
    >
      <el-carousel-item
        v-for="item in h5Lists"
        :key="item.title"
        style="height: 311px; overflow: hidden;"
      >
        <el-image style="width: 100%; height: 311px; object-fit: cover;" :src="item.imgUrl" />
        <div class="carousel-captions">
          <h2>{{ item.title }}</h2>
          <p>{{ item.desc }}</p>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { reactive } from "vue";
export default {
  name: "CarouSel",
  setup() {
    const pcLists = reactive([
      {
        title: "领先的边缘云计算节点服务商",
        desc: "为客户提供低时延、低成本、高带宽、海量数据分布处理需求的一站式云计算服务和解决方案",
        imgUrl: require("@/assets/images/navbar.png"),
      },
    ]);
    const h5Lists = reactive([
      {
        title: "",
        desc: "",
        imgUrl: require("@/assets/images/navbar-h5.png"),
      },
    ]);

    return { pcLists, h5Lists };
  },
};
</script>

<style lang="scss" scoped>
.carousel-captions {
  position: absolute;
  right: 15%;
  top: 207px;
  left: clamp(16px, 17.7%, 340px);
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #333333;
  h2 {
    width: min(650px, 100%);
    height: auto;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: 600;
    font-size: 50px;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  p {
    margin-top: 28px;
    width: min(500px, 100%);
    height: auto;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 26px;
    letter-spacing: 1px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .carousel-btn {
    width: 198px;
    height: 64px;
    margin-top: 35px;
  }
}

@media screen and (max-width: 768px) {
  .carousel-captions {
    left: 16px;
    right: 16px;
    top: 140px;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    h2 {
      font-size: 24px;
      width: 100%;
    }
    p {
      font-size: 13px;
      line-height: 1.6;
      margin-top: 16px;
      width: 100%;
    }
    .carousel-btn {
      width: 140px;
      height: 46px;
      margin-top: 20px;
    }
  }
}
</style>